import { useEffect, useMemo, useState } from "react";
import {
  RemoteAudioTrack,
  RemoteTrack,
  RemoteVideoTrack,
  Room,
  RoomEvent,
  Track,
} from "livekit-client";

export function useRemoteScreenShareTracks(room?: Room) {
  const [remoteScreenTrack, setRemoteScreenTrack] =
    useState<RemoteVideoTrack>();
  const [remoteSystemAudioTrack, setRemoteSystemAudioTrack] =
    useState<RemoteAudioTrack>();

  useEffect(() => {
    if (!room) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSub = (track: RemoteTrack, publication: any) => {
      if (publication.source === Track.Source.ScreenShare) {
        setRemoteScreenTrack(track as RemoteVideoTrack);
      }
      if (publication.source === Track.Source.ScreenShareAudio) {
        setRemoteSystemAudioTrack(track as RemoteAudioTrack);
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onUnsub = (_: RemoteTrack, publication: any) => {
      if (publication.source === Track.Source.ScreenShare) {
        setRemoteScreenTrack(undefined);
      }
      if (publication.source === Track.Source.ScreenShareAudio) {
        setRemoteSystemAudioTrack(undefined);
      }
    };

    room.on(RoomEvent.TrackSubscribed, onSub);
    room.on(RoomEvent.TrackUnsubscribed, onUnsub);

    return () => {
      room.off(RoomEvent.TrackSubscribed, onSub);
      room.off(RoomEvent.TrackUnsubscribed, onUnsub);
    };
  }, [room]);

  return useMemo(
    () => ({ remoteScreenTrack, remoteSystemAudioTrack }) as const,
    [remoteScreenTrack, remoteSystemAudioTrack]
  );
}
